import type { ReactNode } from "react";

/**
 * Blurs the content it is placed over and shows a card on top, for a long task the content waits
 * for (e.g. a data recomputation): the page stays visible behind but cannot be used meanwhile.
 * Covers its closest positioned parent, which must be `relative`.
 */
const BlurredOverlay = ({ children }: { children: ReactNode }) => {
    return (
        <div className="absolute inset-0 z-20 bg-white/40 backdrop-blur-[6px]" role="status" aria-live="polite">
            {/* Sticky so the card stays in view when the content behind is scrolled */}
            <div className="sticky top-0 flex justify-center px-4 pt-[25vh]">
                <div className="max-w-[460px] rounded-2xl bg-white px-12 py-10 text-center shadow-[0_8px_30px_rgba(0,0,0,0.08)]">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default BlurredOverlay;
